/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TMessagesOfferRequest, TMessagesOfferModel, IMappers, TMessagesOfferResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISendFirstMessageV4Response } from '../../../entities/chat_v3/SendFirstMessageV4Response';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createMessagesOfferModel(parameters: TMessagesOfferRequest): TMessagesOfferModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v4/messages/offer/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IMessagesOfferOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TMessagesOfferRequest;
}

export async function fetchMessagesOffer<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IMessagesOfferOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TMessagesOfferResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createMessagesOfferModel(parameters),
    config,
  )) as FetchResponse<TMessagesOfferResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISendFirstMessageV4Response, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TMessagesOfferResponse>;
}
